import React, { useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { SAVE_COMPANIES } from "../../constant/Apipath";
import { IMaskInput } from 'react-imask';
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

// Custom TextMask component for phone numbers
const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-9]/
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const AddPhoneNumberModal = ({ open, onClose, from, data, onDataSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState("+1");
  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    TEXT_PHONE_CODE = English?.AddPhoneNumberModal?.TEXT_PHONE_CODE,
    TEXT_PHONE_NUMBER_PLACEHOLDER = English?.AddPhoneNumberModal?.TEXT_PHONE_NUMBER_PLACEHOLDER,
    TEXT_ADD_PHONE_NUMBER = English?.AddPhoneNumberModal?.TEXT_ADD_PHONE_NUMBER
  } = multiLanguageData?.AddPhoneNumberModal || {};

  // Handle phone number change
  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
  };

  // Check if phone number is valid (10 digits)
  const isValidPhone = phoneNumber?.replace(/[^0-9]/g, "").length === 10;

  const getSaveObj = () => {
    let saveObject = {
      userId: Number(currentUserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: []
    };

    if (from === "company" || from === "manufacture") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: data?.id,
            Name: data?.name,
            webSite: data?.webSite,
            Active: data?.active || data?.Active, 
            phone: phoneNumber?.replace(/[^0-9]/g, ""), // Save only digits
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1,
            Manufacturer: from === "company" ? false : true
          }
        ]
      };
    }
  };

  const getApiUrl = () => {
    let apiUrl = "";
    if (from === "company" || from === "manufacture") {
      apiUrl = SAVE_COMPANIES;
    }
    return apiUrl;
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setSubmitLoading(true);
      let obj = getSaveObj();
      await Postrequestcall(getApiUrl(), obj, loginData?.accessToken);
      onClose();
      onDataSave();
    } catch (error) {
      console.log("onSubmit-> Error When Submitting Phone Number", error);
      onClose();
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleClose = () => {
    setPhoneNumber("");
    setPhoneCode("+1");
    onClose();
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_ADD_PHONE_NUMBER}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <IconButton
              color="primary"
              onClick={onSubmit}
              disabled={!isValidPhone || submitLoading}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <Grid container spacing={2} sx={{ pb: 2,  pt: 2 }} >
          <Grid size={3}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="phone-code">{TEXT_PHONE_CODE}</InputLabel>
              <Select
                label={TEXT_PHONE_CODE}
                id="phone-code"
                value={phoneCode}
                onChange={(e) => setPhoneCode(e.target.value)}>
                <MenuItem value="+1">+1</MenuItem>
                <MenuItem value="+44">+44</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={9}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="formatted-text-mask-input">
                {TEXT_PHONE_NUMBER_PLACEHOLDER}
              </InputLabel>
              <Input
                value={phoneNumber}
                onChange={(event) => handlePhoneChange(event.target.value)}
                name="textmask"
                id="formatted-text-mask-input"
                inputComponent={TextMaskCustom}
                placeholder="(123) 456-7890"
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddPhoneNumberModal;
